<div class="navbar_mob">
  <div class="bottom_bar">
    <ul class="aside_list">
      <li
        [ngClass]="{
          active_bottom_li: !currentRoute || currentRoute === 'dashboard'
        }"
        [routerLink]="['/dashboard']"
      >
        <div class="lsit_item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class="svg_ic"
              d="M8 2H4C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H8C9.10457 22 10 21.1046 10 20V4C10 2.89543 9.10457 2 8 2ZM4 0C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H8C10.2091 24 12 22.2091 12 20V4C12 1.79086 10.2091 0 8 0H4ZM16 4V5C16 6.10457 16.8954 7 18 7L20 7C21.1046 7 22 6.10457 22 5V4C22 2.89543 21.1046 2 20 2L18 2C16.8954 2 16 2.89543 16 4ZM14 5C14 7.20914 15.7909 9 18 9H20C22.2091 9 24 7.20914 24 5V4C24 1.79086 22.2091 0 20 0H18C15.7909 0 14 1.79086 14 4V5ZM16 20V15C16 13.8954 16.8954 13 18 13H20C21.1046 13 22 13.8954 22 15V20C22 21.1046 21.1046 22 20 22H18C16.8954 22 16 21.1046 16 20ZM18 24C15.7909 24 14 22.2091 14 20V15C14 12.7909 15.7909 11 18 11H20C22.2091 11 24 12.7909 24 15V20C24 22.2091 22.2091 24 20 24H18Z"
              fill="#D1D6DC"
            />
          </svg>
        </div>
      </li>
      <li
        [ngClass]="{
          active_bottom_li: !currentRoute || currentRoute === 'artists'
        }"
        [routerLink]="['/artists']"
      >
        <div class="lsit_item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class="svg_ic"
              d="M4.69571 12.837C3.91861 12.837 3.18219 12.6687 2.52836 12.3504V16.1415C2.52836 20.4962 4.04934 22.1698 8.28193 22.3151V20.3718C8.28193 18.0276 9.60787 16.7439 12.0292 16.7439C14.4504 16.7439 15.7764 18.0276 15.7764 20.3718V22.3147C19.9999 22.1667 21.5181 20.4921 21.5181 16.1415V12.3274C20.8528 12.6606 20.0998 12.837 19.3043 12.837C17.8587 12.837 16.5099 12.1387 15.6327 11.0734C15.5322 11.2126 15.4223 11.3467 15.3031 11.4752C14.4499 12.357 13.2969 12.837 12.0286 12.837C10.7603 12.837 9.60731 12.357 8.78869 11.4752C8.65229 11.3282 8.52806 11.1739 8.4163 11.0129C7.54081 12.1122 6.16848 12.837 4.69571 12.837ZM0.0261021 7.84733C-0.091701 8.96883 0.191702 10.0418 0.826495 10.9215C0.808479 10.9881 0.798873 11.0579 0.798873 11.1295V16.1415C0.798873 21.6447 3.22015 24 8.91592 24H15.1421C20.8263 24 23.2591 21.6447 23.2476 16.1415V11.1295C23.2476 11.0413 23.233 10.9559 23.2061 10.8757C23.818 10.0047 24.0897 8.94944 23.9739 7.84733L23.6511 4.74412C23.1783 1.373 21.5987 0 18.209 0H14.7381H14.6923H9.35365C9.3459 0 9.33817 9.9642e-05 9.33047 0.000297329C9.32288 9.93226e-05 9.31528 0 9.30767 0H5.79105C2.40126 0 0.821665 1.373 0.337409 4.77761L0.0261021 7.84733ZM5.79105 1.67439C3.266 1.67439 2.42432 2.41113 2.05536 4.96737L1.74406 8.01477C1.65182 8.86313 1.91701 9.65567 2.47044 10.2473C3.02388 10.8389 3.80791 11.1626 4.69571 11.1626C6.14848 11.1626 7.49748 9.97939 7.63583 8.58406L8.35069 1.67439H5.79105ZM14.6367 8.77024C14.614 9.36313 14.3872 9.91594 13.9887 10.3478C13.0086 11.397 11.0485 11.397 10.0685 10.3478C9.58425 9.83428 9.35365 9.13103 9.43436 8.38313L10.1262 1.67439H13.9047L14.6347 8.7515L14.6367 8.77024ZM16.3975 8.802C16.6549 10.1004 17.9278 11.1626 19.3043 11.1626C20.1806 11.1626 20.9646 10.8389 21.5296 10.2473C22.083 9.65567 22.3367 8.86313 22.2559 8.01477L21.9331 4.94504C21.5757 2.42229 20.734 1.67439 18.209 1.67439H15.6977L16.3754 8.21569C16.3958 8.41342 16.4031 8.60912 16.3975 8.802ZM14.0469 20.3718V22.3253H10.0114V20.3718C10.0114 18.9653 10.5764 18.4183 12.0292 18.4183C13.4819 18.4183 14.0469 18.9653 14.0469 20.3718Z"
              fill="#D1D6DC"
            />
          </svg>
        </div>
      </li>
      <li
        [ngClass]="{
          active_bottom_li: !currentRoute || currentRoute === 'contents'
        }"
        [routerLink]="['/contents']"
      >
        <div class="lsit_item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class="svg_ic"
              d="M4.69571 12.837C3.91861 12.837 3.18219 12.6687 2.52836 12.3504V16.1415C2.52836 20.4962 4.04934 22.1698 8.28193 22.3151V20.3718C8.28193 18.0276 9.60787 16.7439 12.0292 16.7439C14.4504 16.7439 15.7764 18.0276 15.7764 20.3718V22.3147C19.9999 22.1667 21.5181 20.4921 21.5181 16.1415V12.3274C20.8528 12.6606 20.0998 12.837 19.3043 12.837C17.8587 12.837 16.5099 12.1387 15.6327 11.0734C15.5322 11.2126 15.4223 11.3467 15.3031 11.4752C14.4499 12.357 13.2969 12.837 12.0286 12.837C10.7603 12.837 9.60731 12.357 8.78869 11.4752C8.65229 11.3282 8.52806 11.1739 8.4163 11.0129C7.54081 12.1122 6.16848 12.837 4.69571 12.837ZM0.0261021 7.84733C-0.091701 8.96883 0.191702 10.0418 0.826495 10.9215C0.808479 10.9881 0.798873 11.0579 0.798873 11.1295V16.1415C0.798873 21.6447 3.22015 24 8.91592 24H15.1421C20.8263 24 23.2591 21.6447 23.2476 16.1415V11.1295C23.2476 11.0413 23.233 10.9559 23.2061 10.8757C23.818 10.0047 24.0897 8.94944 23.9739 7.84733L23.6511 4.74412C23.1783 1.373 21.5987 0 18.209 0H14.7381H14.6923H9.35365C9.3459 0 9.33817 9.9642e-05 9.33047 0.000297329C9.32288 9.93226e-05 9.31528 0 9.30767 0H5.79105C2.40126 0 0.821665 1.373 0.337409 4.77761L0.0261021 7.84733ZM5.79105 1.67439C3.266 1.67439 2.42432 2.41113 2.05536 4.96737L1.74406 8.01477C1.65182 8.86313 1.91701 9.65567 2.47044 10.2473C3.02388 10.8389 3.80791 11.1626 4.69571 11.1626C6.14848 11.1626 7.49748 9.97939 7.63583 8.58406L8.35069 1.67439H5.79105ZM14.6367 8.77024C14.614 9.36313 14.3872 9.91594 13.9887 10.3478C13.0086 11.397 11.0485 11.397 10.0685 10.3478C9.58425 9.83428 9.35365 9.13103 9.43436 8.38313L10.1262 1.67439H13.9047L14.6347 8.7515L14.6367 8.77024ZM16.3975 8.802C16.6549 10.1004 17.9278 11.1626 19.3043 11.1626C20.1806 11.1626 20.9646 10.8389 21.5296 10.2473C22.083 9.65567 22.3367 8.86313 22.2559 8.01477L21.9331 4.94504C21.5757 2.42229 20.734 1.67439 18.209 1.67439H15.6977L16.3754 8.21569C16.3958 8.41342 16.4031 8.60912 16.3975 8.802ZM14.0469 20.3718V22.3253H10.0114V20.3718C10.0114 18.9653 10.5764 18.4183 12.0292 18.4183C13.4819 18.4183 14.0469 18.9653 14.0469 20.3718Z"
              fill="#D1D6DC"
            />
          </svg>
        </div>
      </li>
      <li
        [ngClass]="{
          active_bottom_li: !currentRoute || currentRoute === 'listeners'
        }"
        [routerLink]="['/listeners']"
      >
        <div class="lsit_item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class="svg_ic"
              d="M4.69571 12.837C3.91861 12.837 3.18219 12.6687 2.52836 12.3504V16.1415C2.52836 20.4962 4.04934 22.1698 8.28193 22.3151V20.3718C8.28193 18.0276 9.60787 16.7439 12.0292 16.7439C14.4504 16.7439 15.7764 18.0276 15.7764 20.3718V22.3147C19.9999 22.1667 21.5181 20.4921 21.5181 16.1415V12.3274C20.8528 12.6606 20.0998 12.837 19.3043 12.837C17.8587 12.837 16.5099 12.1387 15.6327 11.0734C15.5322 11.2126 15.4223 11.3467 15.3031 11.4752C14.4499 12.357 13.2969 12.837 12.0286 12.837C10.7603 12.837 9.60731 12.357 8.78869 11.4752C8.65229 11.3282 8.52806 11.1739 8.4163 11.0129C7.54081 12.1122 6.16848 12.837 4.69571 12.837ZM0.0261021 7.84733C-0.091701 8.96883 0.191702 10.0418 0.826495 10.9215C0.808479 10.9881 0.798873 11.0579 0.798873 11.1295V16.1415C0.798873 21.6447 3.22015 24 8.91592 24H15.1421C20.8263 24 23.2591 21.6447 23.2476 16.1415V11.1295C23.2476 11.0413 23.233 10.9559 23.2061 10.8757C23.818 10.0047 24.0897 8.94944 23.9739 7.84733L23.6511 4.74412C23.1783 1.373 21.5987 0 18.209 0H14.7381H14.6923H9.35365C9.3459 0 9.33817 9.9642e-05 9.33047 0.000297329C9.32288 9.93226e-05 9.31528 0 9.30767 0H5.79105C2.40126 0 0.821665 1.373 0.337409 4.77761L0.0261021 7.84733ZM5.79105 1.67439C3.266 1.67439 2.42432 2.41113 2.05536 4.96737L1.74406 8.01477C1.65182 8.86313 1.91701 9.65567 2.47044 10.2473C3.02388 10.8389 3.80791 11.1626 4.69571 11.1626C6.14848 11.1626 7.49748 9.97939 7.63583 8.58406L8.35069 1.67439H5.79105ZM14.6367 8.77024C14.614 9.36313 14.3872 9.91594 13.9887 10.3478C13.0086 11.397 11.0485 11.397 10.0685 10.3478C9.58425 9.83428 9.35365 9.13103 9.43436 8.38313L10.1262 1.67439H13.9047L14.6347 8.7515L14.6367 8.77024ZM16.3975 8.802C16.6549 10.1004 17.9278 11.1626 19.3043 11.1626C20.1806 11.1626 20.9646 10.8389 21.5296 10.2473C22.083 9.65567 22.3367 8.86313 22.2559 8.01477L21.9331 4.94504C21.5757 2.42229 20.734 1.67439 18.209 1.67439H15.6977L16.3754 8.21569C16.3958 8.41342 16.4031 8.60912 16.3975 8.802ZM14.0469 20.3718V22.3253H10.0114V20.3718C10.0114 18.9653 10.5764 18.4183 12.0292 18.4183C13.4819 18.4183 14.0469 18.9653 14.0469 20.3718Z"
              fill="#D1D6DC"
            />
          </svg>
        </div>
      </li>
      <li
        class="cursor-pointer"
        [ngClass]="{
          active_bottom_li: !currentRoute || currentRoute === 'inbox'
        }"
        [routerLink]="['/inbox']"
      >
        <div class="lsit_item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class="svg_ic"
              d="M1.67442 7.51391C1.67442 5.41626 2.19973 3.99637 3.10362 3.09499C4.00752 2.19361 5.43138 1.66976 7.53488 1.66976H16.4651C18.5686 1.66976 19.9925 2.19361 20.8964 3.09499C21.8003 3.99637 22.3256 5.41626 22.3256 7.51391V13.0798C22.3256 15.1774 21.8003 16.5973 20.8964 17.4987C19.9925 18.4001 18.5686 18.9239 16.4651 18.9239H15.907C15.2953 18.9239 14.7154 19.216 14.3474 19.6989L14.3442 19.7032L12.6698 21.9295C12.4363 22.2399 12.1856 22.3302 12 22.3302C11.8144 22.3302 11.5637 22.2399 11.3302 21.9295L9.65877 19.7071C9.46571 19.4451 9.19594 19.2595 8.95743 19.1416C8.71587 19.0222 8.40872 18.9239 8.09302 18.9239H7.53488C5.31713 18.9239 3.92803 18.633 3.06293 17.8782C2.22549 17.1475 1.67442 15.7907 1.67442 13.0798V7.51391ZM7.53488 0C5.17327 0 3.24829 0.589325 1.91963 1.91429C0.590969 3.23925 0 5.15888 0 7.51391V13.0798C0 15.9347 0.565209 17.9175 1.96032 19.1348C3.32778 20.328 5.28752 20.5937 7.53488 20.5937H8.08738C8.09041 20.5941 8.09999 20.5956 8.11616 20.5999C8.14362 20.6073 8.17784 20.6199 8.21374 20.6376C8.24972 20.6554 8.27902 20.6743 8.2992 20.6899C8.30739 20.6963 8.31242 20.7008 8.3149 20.7032L8.31628 20.705L9.9907 22.9314C10.494 23.6005 11.2145 24 12 24C12.7855 24 13.506 23.6005 14.0093 22.9314L15.6805 20.7093L15.6817 20.7077C15.7379 20.635 15.8271 20.5937 15.907 20.5937H16.4651C18.8267 20.5937 20.7517 20.0044 22.0804 18.6794C23.409 17.3544 24 15.4348 24 13.0798V7.51391C24 5.15888 23.409 3.23925 22.0804 1.91429C20.7517 0.589325 18.8267 0 16.4651 0H7.53488ZM16.4612 9.74026C15.8447 9.74026 15.3449 10.2386 15.3449 10.8534C15.3449 11.4682 15.8447 11.9666 16.4612 11.9666H16.4712C17.0877 11.9666 17.5875 11.4682 17.5875 10.8534C17.5875 10.2386 17.0877 9.74026 16.4712 9.74026H16.4612ZM10.8787 10.8534C10.8787 10.2386 11.3785 9.74026 11.995 9.74026H12.005C12.6215 9.74026 13.1213 10.2386 13.1213 10.8534C13.1213 11.4682 12.6215 11.9666 12.005 11.9666H11.995C11.3785 11.9666 10.8787 11.4682 10.8787 10.8534ZM7.52875 9.74026C6.91225 9.74026 6.41247 10.2386 6.41247 10.8534C6.41247 11.4682 6.91225 11.9666 7.52875 11.9666H7.53878C8.15528 11.9666 8.65506 11.4682 8.65506 10.8534C8.65506 10.2386 8.15528 9.74026 7.53878 9.74026H7.52875Z"
              fill="#D1D6DC"
            />
          </svg>
        </div>
      </li>
      <li
        class="cursor-pointer"
        [ngClass]="{
          active_bottom_li: !currentRoute || currentRoute === 'finance'
        }"
        [routerLink]="['/finance']"
      >
        <div class="lsit_item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class="svg_ic"
              d="M8.65116 24H15.3488C21.4102 24 24 21.4102 24 15.3488V8.65116C24 2.58977 21.4102 0 15.3488 0H8.65116C2.58977 0 0 2.58977 0 8.65116V15.3488C0 21.4102 2.58977 24 8.65116 24ZM1.67442 8.65116C1.67442 3.50512 3.50512 1.67442 8.65116 1.67442H15.3488C20.4949 1.67442 22.3256 3.50512 22.3256 8.65116V15.3488C22.3256 20.4949 20.4949 22.3256 15.3488 22.3256H8.65116C3.50512 22.3256 1.67442 20.4949 1.67442 15.3488V8.65116ZM9.90317 18.8651H14.1098L14.1234 18.865H18.3403C18.8091 18.865 19.1775 18.4854 19.1775 18.0277V14.2212C19.1775 13.0603 18.2287 12.1114 17.0677 12.1114H14.9581V7.24456C14.9581 6.08363 14.0093 5.13477 12.8484 5.13477H11.1516C9.99068 5.13477 9.04186 6.08363 9.04186 7.24456V10.2028H6.93155C5.77062 10.2028 4.8218 11.1517 4.8218 12.3126V18.028C4.8218 18.4856 5.20134 18.8652 5.65901 18.8652H9.88968L9.90317 18.8651ZM10.7274 17.1906H13.2724V12.9486C13.2724 12.9024 13.2763 12.8569 13.2837 12.8125V7.24456C13.2837 7.01014 13.094 6.80919 12.8484 6.80919H11.1516C10.9172 6.80919 10.7163 6.99898 10.7163 7.24456V10.9082C10.7233 10.9512 10.7269 10.9953 10.7269 11.04V17.1906H10.7274ZM17.5031 17.1905H14.9581V13.7858H17.0677C17.3133 13.7858 17.5031 13.9868 17.5031 14.2212V17.1905ZM9.04186 11.8884V17.1908H6.49622V12.3237C6.49622 12.0781 6.69713 11.8884 6.93155 11.8884H9.04186Z"
              fill="#D1D6DC"
            />
          </svg>
        </div>
      </li>
      <li
        class="cursor-pointer"
        [routerLink]="['/user-tokens']"
        [ngClass]="{ list_active: currentRoute === 'user-tokens' }"
      >
        <div class="lsit_item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class="active_icon"
              d="M16.4651 24H1.95349C0.88186 24 0 23.1181 0 22.0465V7.53488C0 2.60093 2.60093 0 7.53488 0H16.4651C21.3991 0 24 2.60093 24 7.53488V16.4651C24 21.3991 21.3991 24 16.4651 24ZM7.53488 1.67442C3.5386 1.67442 1.67442 3.5386 1.67442 7.53488V22.0465C1.67442 22.2028 1.79721 22.3256 1.95349 22.3256H16.4651C20.4614 22.3256 22.3256 20.4614 22.3256 16.4651V7.53488C22.3256 3.5386 20.4614 1.67442 16.4651 1.67442H7.53488ZM17.5812 10.0465H6.41839C5.96071 10.0465 5.58118 9.66698 5.58118 9.2093C5.58118 8.75163 5.96071 8.37209 6.41839 8.37209H17.5812C18.0389 8.37209 18.4184 8.75163 18.4184 9.2093C18.4184 9.66698 18.0389 10.0465 17.5812 10.0465ZM6.41839 15.6277H14.2323C14.69 15.6277 15.0695 15.2482 15.0695 14.7905C15.0695 14.3328 14.69 13.9533 14.2323 13.9533H6.41839C5.96071 13.9533 5.58118 14.3328 5.58118 14.7905C5.58118 15.2482 5.96071 15.6277 6.41839 15.6277Z"
              fill="#D1D6DC"
            />
          </svg>
        </div>
      </li>
      <li
        class="cursor-pointer"
        [ngClass]="{
          active_bottom_li: !currentRoute || currentRoute === 'staff'
        }"
        [routerLink]="['/staff']"
      >
        <div class="lsit_item">
          <svg
            width="22"
            height="24"
            viewBox="0 0 22 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class="svg_ic"
              d="M3.93104 6.4186C3.93104 9.95721 6.75634 12.8372 10.2277 12.8372C13.6991 12.8372 16.5244 9.95721 16.5244 6.4186C16.5244 2.88 13.6991 0 10.2277 0C6.75634 0 3.93104 2.88 3.93104 6.4186ZM5.57366 6.4186C5.57366 3.80651 7.66525 1.67442 10.2277 1.67442C12.7902 1.67442 14.8818 3.80651 14.8818 6.4186C14.8818 9.0307 12.7902 11.1628 10.2277 11.1628C7.66525 11.1628 5.57366 9.0307 5.57366 6.4186ZM0 23.1627C0 23.6204 0.372326 23.9999 0.821306 23.9999C1.27029 23.9999 1.64261 23.6204 1.64261 23.1627C1.64261 19.3115 5.49727 16.1859 10.228 16.1859C10.8737 16.1859 11.5097 16.2411 12.1291 16.3547C11.7819 17.0732 11.5968 17.8697 11.5968 18.6977C11.5968 19.6688 11.8596 20.6177 12.3414 21.4214C12.6042 21.8791 12.9437 22.2921 13.327 22.627C14.2797 23.5089 15.5062 24 16.7984 24C18.6162 24 20.3245 23.0177 21.2334 21.4326C21.5182 20.9749 21.7262 20.4502 21.8357 19.9479C21.9453 19.546 22 19.1219 22 18.6977C22 17.3805 21.5182 16.1303 20.664 15.1591C19.7003 14.0428 18.2877 13.3953 16.7984 13.3953C15.4318 13.3953 14.156 13.92 13.1842 14.8803C12.2224 14.6317 11.2343 14.5115 10.228 14.5115C4.58836 14.5115 0 18.3962 0 23.1627ZM16.7984 15.0698C15.8238 15.0698 14.9258 15.4604 14.2469 16.1637C13.6008 16.8446 13.2394 17.7377 13.2394 18.6977C13.2394 19.3563 13.4146 20.0037 13.7541 20.5618C13.9293 20.8744 14.1592 21.1535 14.4221 21.3879C15.0791 22.0018 15.9223 22.3368 16.7984 22.3368C18.0358 22.3368 19.2076 21.667 19.8427 20.5842C20.0289 20.2716 20.1712 19.9144 20.2479 19.5684C20.3245 19.2782 20.3574 18.9991 20.3574 18.7088C20.3574 17.8158 20.0289 16.9563 19.4375 16.2865C18.7805 15.5051 17.8168 15.0698 16.7984 15.0698ZM16.1626 16H15V21H16.1394V19.4473H16.5611L17.8262 21H19L17.5069 19.0872L19 17.5345H17.7581L16.5155 18.8653H16.1626V16Z"
              fill="#D1D6DC"
            />
          </svg>
        </div>
      </li>
      <li
        class="cursor-pointer"
        [ngClass]="{
          active_bottom_li: !currentRoute || currentRoute === 'category'
        }"
        [routerLink]="['/category']"
      >
        <div class="lsit_item">
          <svg
            width="24"
            height="20"
            viewBox="0 0 24 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class="svg_ic"
              d="M0 2C0 0.893333 0.869189 0 1.94595 0C3.0227 0 3.89189 0.893333 3.89189 2C3.89189 3.10667 3.0227 4 1.94595 4C0.869189 4 0 3.10667 0 2ZM0 9.9999C0 8.89324 0.869189 7.99991 1.94595 7.99991C3.0227 7.99991 3.89189 8.89324 3.89189 9.9999C3.89189 11.1066 3.0227 11.9999 1.94595 11.9999C0.869189 11.9999 0 11.1066 0 9.9999ZM1.94595 15.9998C0.869189 15.9998 0 16.9065 0 17.9998C0 19.0931 0.882162 19.9998 1.94595 19.9998C3.00973 19.9998 3.89189 19.0931 3.89189 17.9998C3.89189 16.9065 3.0227 15.9998 1.94595 15.9998ZM24.0001 19.3334H5.83789V16.6668H24.0001V19.3334ZM5.83789 11.3335H24.0001V8.66686H5.83789V11.3335ZM5.83789 3.33312V0.66645H24.0001V3.33312H5.83789Z"
              fill="#D1D6DC"
            />
          </svg>
        </div>
      </li>
      <li
        class="cursor-pointer"
        [ngClass]="{
          active_bottom_li: !currentRoute || currentRoute === 'radio'
        }"
        [routerLink]="['/radio']"
      >
        <div class="lsit_item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class="active_icon"
              d="M6.46789 0.116412C5.97978 -0.141995 5.37462 0.0442094 5.11621 0.532312C4.85781 1.02042 5.04401 1.62558 5.53211 1.88399L21.4679 10.3206C21.7953 10.4939 22 10.834 22 11.2044V21.0002C22 21.5525 21.5523 22.0002 21 22.0002H3C2.44772 22.0002 2 21.5525 2 21.0002V11.0002C2 10.4479 2.44772 10.0002 3 10.0002H14C14.5523 10.0002 15 9.55249 15 9.0002C15 8.44792 14.5523 8.0002 14 8.0002H3C1.34315 8.0002 0 9.34335 0 11.0002V21.0002C0 22.6571 1.34315 24.0002 3 24.0002H21C22.6569 24.0002 24 22.6571 24 21.0002V11.2044C24 10.0931 23.3858 9.07293 22.4037 8.553L6.46789 0.116412ZM10 16.0002C10 17.1048 9.10457 18.0002 8 18.0002C6.89543 18.0002 6 17.1048 6 16.0002C6 14.8957 6.89543 14.0002 8 14.0002C9.10457 14.0002 10 14.8957 10 16.0002ZM12 16.0002C12 18.2094 10.2091 20.0002 8 20.0002C5.79086 20.0002 4 18.2094 4 16.0002C4 13.7911 5.79086 12.0002 8 12.0002C10.2091 12.0002 12 13.7911 12 16.0002ZM14 14.0002C14 13.448 14.4477 13.0002 15 13.0002H19C19.5523 13.0002 20 13.448 20 14.0002C20 14.5525 19.5523 15.0002 19 15.0002H15C14.4477 15.0002 14 14.5525 14 14.0002ZM15 17.0002C14.4477 17.0002 14 17.448 14 18.0002C14 18.5525 14.4477 19.0002 15 19.0002H19C19.5523 19.0002 20 18.5525 20 18.0002C20 17.448 19.5523 17.0002 19 17.0002H15Z"
              fill="#D1D6DC"
            />
          </svg>
        </div>
      </li>
      <li
        class="cursor-pointer"
        [ngClass]="{ activelist: currentRoute === 'fan-club-plans' }"
        [routerLink]="['/fan-club-plans']"
      >
        <div class="lsit_item">
          <img src="assets/images/fan-club.png" />
        </div>
      </li>

      <li
        [ngClass]="{
          active_bottom_li: !currentRoute || currentRoute === 'token'
        }"
        [routerLink]="['/token']"
      >
        <div class="lsit_item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class="svg_ic"
              d="M16.4651 24H1.95349C0.88186 24 0 23.1181 0 22.0465V7.53488C0 2.60093 2.60093 0 7.53488 0H16.4651C21.3991 0 24 2.60093 24 7.53488V16.4651C24 21.3991 21.3991 24 16.4651 24ZM7.53488 1.67442C3.5386 1.67442 1.67442 3.5386 1.67442 7.53488V22.0465C1.67442 22.2028 1.79721 22.3256 1.95349 22.3256H16.4651C20.4614 22.3256 22.3256 20.4614 22.3256 16.4651V7.53488C22.3256 3.5386 20.4614 1.67442 16.4651 1.67442H7.53488ZM17.5812 10.0465H6.41839C5.96071 10.0465 5.58118 9.66698 5.58118 9.2093C5.58118 8.75163 5.96071 8.37209 6.41839 8.37209H17.5812C18.0389 8.37209 18.4184 8.75163 18.4184 9.2093C18.4184 9.66698 18.0389 10.0465 17.5812 10.0465ZM6.41839 15.6277H14.2323C14.69 15.6277 15.0695 15.2482 15.0695 14.7905C15.0695 14.3328 14.69 13.9533 14.2323 13.9533H6.41839C5.96071 13.9533 5.58118 14.3328 5.58118 14.7905C5.58118 15.2482 5.96071 15.6277 6.41839 15.6277Z"
              fill="#D1D6DC"
            />
          </svg>
        </div>
      </li>
      <li
        class="cursor-pointer"
        [ngClass]="{ activelist: currentRoute === 'Subscription' }"
        [routerLink]="['/Subscription']"
      >
        <div class="lsit_item">
          <img src="assets/images/subscription.png" class="Subscription-img" />
        </div>
      </li>
      <li
        class="cursor-pointer"
        [routerLink]="['/promo-code']"
        [ngClass]="{ activelist: currentRoute === 'promo-code' }"
      >
        <div class="lsit_item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class="active_icon"
              d="M9.76657 24H17.5814C22.5042 24 24 22.1623 24 16.1143C24 15.552 23.6205 15.0857 23.1628 15.0857C22.0912 15.0857 21.2093 14.0023 21.2093 12.6857C21.2093 11.3691 22.0912 10.2857 23.1628 10.2857C23.6205 10.2857 24 9.81943 24 9.25714V7.88571C24 1.83771 22.5042 0 17.5814 0H9.76657H6.4186C1.49581 0 0 1.83771 0 7.88571V8.57143C0 9.13371 0.379535 9.6 0.837209 9.6C1.90884 9.6 2.7907 10.6834 2.7907 12C2.7907 13.3166 1.90884 14.4 0.837209 14.4C0.379535 14.4 0 14.8663 0 15.4286V16.1143C0 22.1623 1.49581 24 6.4186 24H9.76657ZM8.92936 21.9429H6.4186C2.4893 21.9429 1.69674 21.0514 1.67442 16.3337C3.2707 15.8674 4.46512 14.0983 4.46512 12C4.46512 9.90171 3.2707 8.13257 1.67442 7.66629C1.69674 2.94857 2.4893 2.05714 6.4186 2.05714H8.92936V4.45714C8.92936 5.01943 9.30889 5.48571 9.76657 5.48571C10.2242 5.48571 10.6038 5.01943 10.6038 4.45714V2.05714H17.5814C21.5777 2.05714 22.3256 2.98971 22.3256 7.88571V8.352C20.7293 8.81829 19.5349 10.5874 19.5349 12.6857C19.5349 14.784 20.7181 16.5531 22.3144 17.0194C22.214 21.1337 21.3098 21.9429 17.5814 21.9429H10.6038V19.5429C10.6038 18.9806 10.2242 18.5143 9.76657 18.5143C9.30889 18.5143 8.92936 18.9806 8.92936 19.5429V21.9429ZM9.76657 15.5386C9.30889 15.5386 8.92936 15.0723 8.92936 14.5101V9.47692C8.92936 8.91464 9.30889 8.44835 9.76657 8.44835C10.2242 8.44835 10.6038 8.91464 10.6038 9.47692V14.5101C10.6038 15.0861 10.2242 15.5386 9.76657 15.5386Z"
              fill="#D1D6DC"
            />
          </svg>
        </div>
      </li>

      <li
        class="cursor-pointer"
        [routerLink]="['/ads']"
        [ngClass]="{ list_active: currentRoute === 'ads' }"
      >
        <div class="lsit_item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class="active_icon"
              d="M16.4651 24H1.95349C0.88186 24 0 23.1181 0 22.0465V7.53488C0 2.60093 2.60093 0 7.53488 0H16.4651C21.3991 0 24 2.60093 24 7.53488V16.4651C24 21.3991 21.3991 24 16.4651 24ZM7.53488 1.67442C3.5386 1.67442 1.67442 3.5386 1.67442 7.53488V22.0465C1.67442 22.2028 1.79721 22.3256 1.95349 22.3256H16.4651C20.4614 22.3256 22.3256 20.4614 22.3256 16.4651V7.53488C22.3256 3.5386 20.4614 1.67442 16.4651 1.67442H7.53488ZM17.5812 10.0465H6.41839C5.96071 10.0465 5.58118 9.66698 5.58118 9.2093C5.58118 8.75163 5.96071 8.37209 6.41839 8.37209H17.5812C18.0389 8.37209 18.4184 8.75163 18.4184 9.2093C18.4184 9.66698 18.0389 10.0465 17.5812 10.0465ZM6.41839 15.6277H14.2323C14.69 15.6277 15.0695 15.2482 15.0695 14.7905C15.0695 14.3328 14.69 13.9533 14.2323 13.9533H6.41839C5.96071 13.9533 5.58118 14.3328 5.58118 14.7905C5.58118 15.2482 5.96071 15.6277 6.41839 15.6277Z"
              fill="#D1D6DC"
            />
          </svg>
        </div>
      </li>
      <li
        class="cursor-pointer"
        [routerLink]="['/campaigns']"
        [ngClass]="{ list_active: currentRoute === 'campaigns' }"
      >
        <div class="lsit_item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class="active_icon"
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
              fill="#D1D6DC"
            />
          </svg>
        </div>
      </li>
      <li
        class="cursor-pointer"
        [routerLink]="['/referral-reward']"
        [ngClass]="{ list_active: currentRoute === 'referral-reward' }"
      >
        <div class="lsit_item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class="active_icon"
              d="M16.4651 24H1.95349C0.88186 24 0 23.1181 0 22.0465V7.53488C0 2.60093 2.60093 0 7.53488 0H16.4651C21.3991 0 24 2.60093 24 7.53488V16.4651C24 21.3991 21.3991 24 16.4651 24ZM7.53488 1.67442C3.5386 1.67442 1.67442 3.5386 1.67442 7.53488V22.0465C1.67442 22.2028 1.79721 22.3256 1.95349 22.3256H16.4651C20.4614 22.3256 22.3256 20.4614 22.3256 16.4651V7.53488C22.3256 3.5386 20.4614 1.67442 16.4651 1.67442H7.53488ZM17.5812 10.0465H6.41839C5.96071 10.0465 5.58118 9.66698 5.58118 9.2093C5.58118 8.75163 5.96071 8.37209 6.41839 8.37209H17.5812C18.0389 8.37209 18.4184 8.75163 18.4184 9.2093C18.4184 9.66698 18.0389 10.0465 17.5812 10.0465ZM6.41839 15.6277H14.2323C14.69 15.6277 15.0695 15.2482 15.0695 14.7905C15.0695 14.3328 14.69 13.9533 14.2323 13.9533H6.41839C5.96071 13.9533 5.58118 14.3328 5.58118 14.7905C5.58118 15.2482 5.96071 15.6277 6.41839 15.6277Z"
              fill="#D1D6DC"
            />
          </svg>
        </div>
      </li>
      <li
        class="cursor-pointer"
        [routerLink]="['/referral-level']"
        [ngClass]="{ list_active: currentRoute === 'referral-level' }"
      >
        <div class="lsit_item">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class="active_icon"
              d="M16.4651 24H1.95349C0.88186 24 0 23.1181 0 22.0465V7.53488C0 2.60093 2.60093 0 7.53488 0H16.4651C21.3991 0 24 2.60093 24 7.53488V16.4651C24 21.3991 21.3991 24 16.4651 24ZM7.53488 1.67442C3.5386 1.67442 1.67442 3.5386 1.67442 7.53488V22.0465C1.67442 22.2028 1.79721 22.3256 1.95349 22.3256H16.4651C20.4614 22.3256 22.3256 20.4614 22.3256 16.4651V7.53488C22.3256 3.5386 20.4614 1.67442 16.4651 1.67442H7.53488ZM17.5812 10.0465H6.41839C5.96071 10.0465 5.58118 9.66698 5.58118 9.2093C5.58118 8.75163 5.96071 8.37209 6.41839 8.37209H17.5812C18.0389 8.37209 18.4184 8.75163 18.4184 9.2093C18.4184 9.66698 18.0389 10.0465 17.5812 10.0465ZM6.41839 15.6277H14.2323C14.69 15.6277 15.0695 15.2482 15.0695 14.7905C15.0695 14.3328 14.69 13.9533 14.2323 13.9533H6.41839C5.96071 13.9533 5.58118 14.3328 5.58118 14.7905C5.58118 15.2482 5.96071 15.6277 6.41839 15.6277Z"
              fill="#D1D6DC"
            />
          </svg>
        </div>
      </li>

      <li
        class="cursor-pointer"
        [routerLink]="['/referral-milestone']"
        [ngClass]="{ list_active: currentRoute === 'referral-milestone' }"
      >
        <div class="lsit_item">
         <!-- <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class="active_icon"
              d="M16.4651 24H1.95349C0.88186 24 0 23.1181 0 22.0465V7.53488C0 2.60093 2.60093 0 7.53488 0H16.4651C21.3991 0 24 2.60093 24 7.53488V16.4651C24 21.3991 21.3991 24 16.4651 24ZM7.53488 1.67442C3.5386 1.67442 1.67442 3.5386 1.67442 7.53488V22.0465C1.67442 22.2028 1.79721 22.3256 1.95349 22.3256H16.4651C20.4614 22.3256 22.3256 20.4614 22.3256 16.4651V7.53488C22.3256 3.5386 20.4614 1.67442 16.4651 1.67442H7.53488ZM17.5812 10.0465H6.41839C5.96071 10.0465 5.58118 9.66698 5.58118 9.2093C5.58118 8.75163 5.96071 8.37209 6.41839 8.37209H17.5812C18.0389 8.37209 18.4184 8.75163 18.4184 9.2093C18.4184 9.66698 18.0389 10.0465 17.5812 10.0465ZM6.41839 15.6277H14.2323C14.69 15.6277 15.0695 15.2482 15.0695 14.7905C15.0695 14.3328 14.69 13.9533 14.2323 13.9533H6.41839C5.96071 13.9533 5.58118 14.3328 5.58118 14.7905C5.58118 15.2482 5.96071 15.6277 6.41839 15.6277Z"
              fill="#D1D6DC"
            />
          </svg>-->

          <svg
            width=24
            height=24
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              class="active_icon"
              d="M16.4651 24H1.95349C0.88186 24 0 23.1181 0 22.0465V7.53488C0 2.60093 2.60093 0 7.53488 0H16.4651C21.3991 0 24 2.60093 24 7.53488V16.4651C24 21.3991 21.3991 24 16.4651 24ZM7.53488 1.67442C3.5386 1.67442 1.67442 3.5386 1.67442 7.53488V22.0465C1.67442 22.2028 1.79721 22.3256 1.95349 22.3256H16.4651C20.4614 22.3256 22.3256 20.4614 22.3256 16.4651V7.53488C22.3256 3.5386 20.4614 1.67442 16.4651 1.67442H7.53488ZM17.5812 10.0465H6.41839C5.96071 10.0465 5.58118 9.66698 5.58118 9.2093C5.58118 8.75163 5.96071 8.37209 6.41839 8.37209H17.5812C18.0389 8.37209 18.4184 8.75163 18.4184 9.2093C18.4184 9.66698 18.0389 10.0465 17.5812 10.0465ZM6.41839 15.6277H14.2323C14.69 15.6277 15.0695 15.2482 15.0695 14.7905C15.0695 14.3328 14.69 13.9533 14.2323 13.9533H6.41839C5.96071 13.9533 5.58118 14.3328 5.58118 14.7905C5.58118 15.2482 5.96071 15.6277 6.41839 15.6277Z"
              fill="#D1D6DC"
            />
          </svg>
        </div>
      </li>

<!--      <li-->
<!--        class="cursor-pointer"-->
<!--        [routerLink]="['/distribute-tokens']"-->
<!--        [ngClass]="{ list_active: currentRoute === 'distribute-tokens' }"-->
<!--      >-->
<!--        <div class="lsit_item">-->
<!--          <img class="img-wrapper w-auto coin-icon" src="assets/images/token-coin.png" />-->
<!--        </div>-->
<!--      </li>-->
      <li
        class="cursor-pointer"
        [routerLink]="['/users-streams']"
        [ngClass]="{ list_active: currentRoute === 'users-streams' }"
      >
        <div class="lsit_item">
          <img class="img-wrapper w-auto coin-icon" src="assets/images/Streams.svg" />
        </div>
      </li>
    </ul>
  </div>
</div>
